var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr',{staticClass:"dotted-hr"}),_c('div',[_c('OrderProductsList',{ref:"checkoutorderr",on:{"customEvent":_vm.handleCustomEvent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }